import React from 'react';
import { Skeleton } from 'antd';
import { DefaultPageLayout } from 'layouts/default-page-layout';
import { useGetManyInvoices } from 'api/invoices/use-get-many-invoices.ts';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard';
import { useInitFiltersFromUrl } from 'shared/hooks/use-init-filters-from-url';
import { usePageReset } from 'shared/hooks/use-page-reset';
import { usePaginationParams } from 'shared/hooks/use-pagination-params.ts';
import { useInvoiceFiltersStore, type IInvoicesFilter } from 'shared/stores/use-invoices-filters.ts';
import { InvoicesList } from 'components/invoices/invoices-list';
import { InvoicesListPageHeader } from 'components/invoices/invoices-list-page-header';
import { InvoicesSummary } from 'components/invoices/invoices-summary';
import { Pagination } from 'components/pagination';

export const InvoicesListPageComponent: React.FC = () => {
  const { page, limit, handlePageChange } = usePaginationParams();
  const { search, filters, setFilters } = useInvoiceFiltersStore();
  const { data: invoices, isLoading, isPreviousData } = useGetManyInvoices({ page, limit, search, filters });

  useInitFiltersFromUrl<IInvoicesFilter>({ schema: { overdue: 'boolean' }, setFilters });
  usePageReset([filters, search]);

  return (
    <DefaultPageLayout header={<InvoicesListPageHeader />}>
      <Skeleton loading={isLoading}>
        <InvoicesSummary />
        <InvoicesList invoices={invoices?.data || []} isLoading={isPreviousData} withCheckbox />
        <Pagination
          total={invoices?.pagination?.total}
          page={invoices?.pagination?.currentPage}
          limit={invoices?.pagination?.limit}
          onChange={handlePageChange}
        />
      </Skeleton>
    </DefaultPageLayout>
  );
};

export const InvoicesListPage = withRoleGuard(InvoicesListPageComponent, [
  UserRole.assistant,
  UserRole.admin,
  UserRole.accountant,
]);
